export default __webpack_public_path__ + "static/media/art-0-main-sm.7ddf77c7.jpg";